/**
 * Created by Ning Jiang on 2021-05-27.
 */

import {ReelStopPresentationController} from "../ReelStopPresentationController";
import {IReelStateEventData, ReelState} from "../../../core/reel/ReelState";
import {DeadwoodRipSound} from "../../sound/DeadwoodRipSound";
import {DeadwoodRip} from "../../DeadwoodRip";

export class ReelStopSoundController extends ReelStopPresentationController {

    private _spinStates:boolean[];

    constructor() {
        super('ReelStopSoundController');
    }

    public async start():Promise<any> {
        this._spinStates = DeadwoodRip.reels.map(reel => reel.reelState === ReelState.SPIN);
        await super.start();
    }

    protected onReelBounce(data:IReelStateEventData):Promise<any> {
        const sound = DeadwoodRipSound.playRandomReelLandingSound();
        if(sound) {
            sound.player.stereo(DeadwoodRipSound._davidPanningReelStop[data.reelId]);
        }

        this._spinStates[data.reelId] = false;
        if(this._spinStates.every(s => !s)) {
            DeadwoodRipSound.soundPlayer.stopTrack(DeadwoodRipSound.REELS_SPINNING);
        }
        return super.onReelBounce(data);
    }
}